(function () {
    'use strict';

    angular
        .module('LayoutBuilder')
        .directive('lbInfoPanel', lbInfoPanelDirective);

    function lbInfoPanelDirective() {
        return {
            restrict: 'EA',
            replace:true,
            scope: {
                panel:'=',
                model:'='
            },
            templateUrl:"common/libraries/layoutBuilder/panels/info",
            controller: lbInfoPanelDirectiveCtrl
        };
    }

    function lbInfoPanelDirectiveCtrl($scope, lodash) {
        this.$onInit = function() {
            $scope.columnSize = columnSize;
            $scope.getModelVisible = getModelVisible;
            $scope.getModelValue = getModuleValue;
        }

        function columnSize(listGroup) {
            if (lodash.has(listGroup,'size')) {
                return "medium-" + listGroup.size;
            }
            return "";
        }

        function getModelVisible(element){
            if(typeof lodash.has(element,'options') === 'undefined'){
                return true;
            }
            if(typeof lodash.has(element, 'options.showIf') === 'undefined'){
                return true;
            }
            var operator = lodash.get(element, 'options.showIf.operator');
            var targetValue = lodash.get(element, 'options.showIf.value');
            var fieldIf = lodash.get(element, 'options.showIf.field','');
            var selectedValue = lodash.get($scope.model, fieldIf);
            switch (operator) {
                case 'eq':
                    return selectedValue === targetValue;
                case 'neq':
                    return selectedValue !== targetValue;
            }
            return true;
        }

        function getModuleValue(element) {
            //var value = $scope.model[element.field];
            var value = lodash.get($scope.model, element.field);

            if (angular.isArray(value)) {
                var dataTextField = lodash.get(element, 'options.dataTextField');

                if (typeof dataTextField === 'undefined') {
                    throw new Error('dataTextField must be defined');
                }

                return value.map(function (item) {
                    return item[dataTextField];
                }).join(', ');
            }

            if (typeof value === 'undefined') {
                return 'None set';
            }

            return value;
        }
    }
})();
